import React, { FunctionComponent } from "react";
import ultPage from "ultimate-pagination";
import { Button } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../../helpers";

interface PharmacyPaginationProps {
  currentPage: number;
  pageCount: number;
  handlePageClick: (pageNum: number, scrollToTop: boolean) => void;
  onNextPage: () => void;
  onPrevPage: () => void;
}

const PharmacyPagination: FunctionComponent<PharmacyPaginationProps> = ({
  currentPage,
  pageCount,
  handlePageClick,
  onNextPage,
  onPrevPage,
}) => {
  const t = useTranslate();

  return (
    <nav className="ds-u-margin-top--2" aria-label="pagination">
      <div className="selectPharmacies__pagination">
        {pageCount > 0 &&
          ultPage
            .getPaginationModel({
              currentPage: currentPage + 1,
              hideFirstAndLastPageLinks: true,
              totalPages: pageCount,
            })
            .map(({ type, key, value, isActive }) => (
              <React.Fragment key={key}>
                {
                  {
                    [ultPage.ITEM_TYPES.PREVIOUS_PAGE_LINK]:
                      currentPage === 0 ? null : (
                        <Button
                          aria-label={t("pharm_selection.previous_page")}
                          variation="transparent"
                          className="ds-u-text-decoration--none"
                          name="prev-page"
                          id="prev-page"
                          onClick={onPrevPage}
                          hidden={currentPage === 0}
                        >
                          <span className="fa fa-chevron-left" />{" "}
                          {t("pharm_selection.previous")}
                        </Button>
                      ),
                    [ultPage.ITEM_TYPES.PAGE]: (
                      <Button
                        variation="transparent"
                        className={
                          isActive
                            ? "page-number ds-u-text-decoration--none"
                            : "page-number"
                        }
                        disabled={isActive}
                        onClick={(): void => handlePageClick(value - 1, true)}
                      >
                        {value}
                      </Button>
                    ),
                    [ultPage.ITEM_TYPES.ELLIPSIS]: <span>...</span>,
                    [ultPage.ITEM_TYPES.NEXT_PAGE_LINK]:
                      currentPage >= pageCount - 1 ? null : (
                        <Button
                          variation="transparent"
                          className="ds-u-text-decoration--none"
                          aria-label={t("pharm_selection.next_page")}
                          name="next-page"
                          id="next-page"
                          onClick={onNextPage}
                          hidden={currentPage >= pageCount - 1}
                        >
                          {t("pharm_selection.next")}{" "}
                          <span className="fa fa-chevron-right" />
                        </Button>
                      ),
                  }[type]
                }
              </React.Fragment>
            ))}
      </div>
    </nav>
  );
};

export default PharmacyPagination;
